// Destinations offered by the international delivery method: ISO 3166-1 alpha-2, officially
// assigned codes only, sorted by their Polish name. Poland is absent on purpose — a parcel
// staying in the country goes through paczkomat or kurier, which are priced up front. The seven
// territories with no international dialling code are absent too: checkout asks every buyer for a
// phone number, and one it could never accept is a destination it could never sell to.
// Keep in sync with apps/api/src/util/shippingCountries.ts.

export const SHIPPING_COUNTRIES = [
  { iso: 'AF', name: 'Afganistan' },
  { iso: 'AL', name: 'Albania' },
  { iso: 'DZ', name: 'Algieria' },
  { iso: 'AD', name: 'Andora' },
  { iso: 'AO', name: 'Angola' },
  { iso: 'AI', name: 'Anguilla' },
  { iso: 'AG', name: 'Antigua i Barbuda' },
  { iso: 'SA', name: 'Arabia Saudyjska' },
  { iso: 'AR', name: 'Argentyna' },
  { iso: 'AM', name: 'Armenia' },
  { iso: 'AW', name: 'Aruba' },
  { iso: 'AU', name: 'Australia' },
  { iso: 'AT', name: 'Austria' },
  { iso: 'AZ', name: 'Azerbejdżan' },
  { iso: 'BS', name: 'Bahamy' },
  { iso: 'BH', name: 'Bahrajn' },
  { iso: 'BD', name: 'Bangladesz' },
  { iso: 'BB', name: 'Barbados' },
  { iso: 'BE', name: 'Belgia' },
  { iso: 'BZ', name: 'Belize' },
  { iso: 'BJ', name: 'Benin' },
  { iso: 'BM', name: 'Bermudy' },
  { iso: 'BT', name: 'Bhutan' },
  { iso: 'BY', name: 'Białoruś' },
  { iso: 'BO', name: 'Boliwia' },
  { iso: 'BA', name: 'Bośnia i Hercegowina' },
  { iso: 'BW', name: 'Botswana' },
  { iso: 'BR', name: 'Brazylia' },
  { iso: 'BN', name: 'Brunei' },
  { iso: 'IO', name: 'Brytyjskie Terytorium Oceanu Indyjskiego' },
  { iso: 'VG', name: 'Brytyjskie Wyspy Dziewicze' },
  { iso: 'BG', name: 'Bułgaria' },
  { iso: 'BF', name: 'Burkina Faso' },
  { iso: 'BI', name: 'Burundi' },
  { iso: 'CL', name: 'Chile' },
  { iso: 'CN', name: 'Chiny' },
  { iso: 'HR', name: 'Chorwacja' },
  { iso: 'CI', name: 'Côte d’Ivoire' },
  { iso: 'CW', name: 'Curaçao' },
  { iso: 'CY', name: 'Cypr' },
  { iso: 'TD', name: 'Czad' },
  { iso: 'ME', name: 'Czarnogóra' },
  { iso: 'CZ', name: 'Czechy' },
  { iso: 'DK', name: 'Dania' },
  { iso: 'CD', name: 'Demokratyczna Republika Konga' },
  { iso: 'DM', name: 'Dominika' },
  { iso: 'DO', name: 'Dominikana' },
  { iso: 'DJ', name: 'Dżibuti' },
  { iso: 'EG', name: 'Egipt' },
  { iso: 'EC', name: 'Ekwador' },
  { iso: 'ER', name: 'Erytrea' },
  { iso: 'EE', name: 'Estonia' },
  { iso: 'SZ', name: 'Eswatini' },
  { iso: 'ET', name: 'Etiopia' },
  { iso: 'FK', name: 'Falklandy' },
  { iso: 'FJ', name: 'Fidżi' },
  { iso: 'PH', name: 'Filipiny' },
  { iso: 'FI', name: 'Finlandia' },
  { iso: 'FR', name: 'Francja' },
  { iso: 'GA', name: 'Gabon' },
  { iso: 'GM', name: 'Gambia' },
  { iso: 'GH', name: 'Ghana' },
  { iso: 'GI', name: 'Gibraltar' },
  { iso: 'GR', name: 'Grecja' },
  { iso: 'GD', name: 'Grenada' },
  { iso: 'GL', name: 'Grenlandia' },
  { iso: 'GE', name: 'Gruzja' },
  { iso: 'GU', name: 'Guam' },
  { iso: 'GG', name: 'Guernsey' },
  { iso: 'GY', name: 'Gujana' },
  { iso: 'GF', name: 'Gujana Francuska' },
  { iso: 'GP', name: 'Gwadelupa' },
  { iso: 'GT', name: 'Gwatemala' },
  { iso: 'GN', name: 'Gwinea' },
  { iso: 'GW', name: 'Gwinea Bissau' },
  { iso: 'GQ', name: 'Gwinea Równikowa' },
  { iso: 'HT', name: 'Haiti' },
  { iso: 'ES', name: 'Hiszpania' },
  { iso: 'NL', name: 'Holandia' },
  { iso: 'HN', name: 'Honduras' },
  { iso: 'IN', name: 'Indie' },
  { iso: 'ID', name: 'Indonezja' },
  { iso: 'IQ', name: 'Irak' },
  { iso: 'IR', name: 'Iran' },
  { iso: 'IE', name: 'Irlandia' },
  { iso: 'IS', name: 'Islandia' },
  { iso: 'IL', name: 'Izrael' },
  { iso: 'JM', name: 'Jamajka' },
  { iso: 'JP', name: 'Japonia' },
  { iso: 'YE', name: 'Jemen' },
  { iso: 'JE', name: 'Jersey' },
  { iso: 'JO', name: 'Jordania' },
  { iso: 'KY', name: 'Kajmany' },
  { iso: 'KH', name: 'Kambodża' },
  { iso: 'CM', name: 'Kamerun' },
  { iso: 'CA', name: 'Kanada' },
  { iso: 'QA', name: 'Katar' },
  { iso: 'KZ', name: 'Kazachstan' },
  { iso: 'KE', name: 'Kenia' },
  { iso: 'KG', name: 'Kirgistan' },
  { iso: 'KI', name: 'Kiribati' },
  { iso: 'CO', name: 'Kolumbia' },
  { iso: 'KM', name: 'Komory' },
  { iso: 'CG', name: 'Kongo' },
  { iso: 'KR', name: 'Korea Południowa' },
  { iso: 'KP', name: 'Korea Północna' },
  { iso: 'CR', name: 'Kostaryka' },
  { iso: 'CU', name: 'Kuba' },
  { iso: 'KW', name: 'Kuwejt' },
  { iso: 'LA', name: 'Laos' },
  { iso: 'LS', name: 'Lesotho' },
  { iso: 'LB', name: 'Liban' },
  { iso: 'LR', name: 'Liberia' },
  { iso: 'LY', name: 'Libia' },
  { iso: 'LI', name: 'Liechtenstein' },
  { iso: 'LT', name: 'Litwa' },
  { iso: 'LU', name: 'Luksemburg' },
  { iso: 'LV', name: 'Łotwa' },
  { iso: 'MK', name: 'Macedonia Północna' },
  { iso: 'MG', name: 'Madagaskar' },
  { iso: 'YT', name: 'Majotta' },
  { iso: 'MW', name: 'Malawi' },
  { iso: 'MV', name: 'Malediwy' },
  { iso: 'MY', name: 'Malezja' },
  { iso: 'ML', name: 'Mali' },
  { iso: 'MT', name: 'Malta' },
  { iso: 'MP', name: 'Mariany Północne' },
  { iso: 'MA', name: 'Maroko' },
  { iso: 'MQ', name: 'Martynika' },
  { iso: 'MR', name: 'Mauretania' },
  { iso: 'MU', name: 'Mauritius' },
  { iso: 'MX', name: 'Meksyk' },
  { iso: 'FM', name: 'Mikronezja' },
  { iso: 'MM', name: 'Mjanma (Birma)' },
  { iso: 'MD', name: 'Mołdawia' },
  { iso: 'MC', name: 'Monako' },
  { iso: 'MN', name: 'Mongolia' },
  { iso: 'MS', name: 'Montserrat' },
  { iso: 'MZ', name: 'Mozambik' },
  { iso: 'NA', name: 'Namibia' },
  { iso: 'NR', name: 'Nauru' },
  { iso: 'NP', name: 'Nepal' },
  { iso: 'BQ', name: 'Niderlandy Karaibskie' },
  { iso: 'DE', name: 'Niemcy' },
  { iso: 'NE', name: 'Niger' },
  { iso: 'NG', name: 'Nigeria' },
  { iso: 'NI', name: 'Nikaragua' },
  { iso: 'NU', name: 'Niue' },
  { iso: 'NF', name: 'Norfolk' },
  { iso: 'NO', name: 'Norwegia' },
  { iso: 'NC', name: 'Nowa Kaledonia' },
  { iso: 'NZ', name: 'Nowa Zelandia' },
  { iso: 'OM', name: 'Oman' },
  { iso: 'PK', name: 'Pakistan' },
  { iso: 'PW', name: 'Palau' },
  { iso: 'PA', name: 'Panama' },
  { iso: 'PG', name: 'Papua-Nowa Gwinea' },
  { iso: 'PY', name: 'Paragwaj' },
  { iso: 'PE', name: 'Peru' },
  { iso: 'PF', name: 'Polinezja Francuska' },
  { iso: 'PR', name: 'Portoryko' },
  { iso: 'PT', name: 'Portugalia' },
  { iso: 'ZA', name: 'Republika Południowej Afryki' },
  { iso: 'CF', name: 'Republika Środkowoafrykańska' },
  { iso: 'CV', name: 'Republika Zielonego Przylądka' },
  { iso: 'RE', name: 'Reunion' },
  { iso: 'RU', name: 'Rosja' },
  { iso: 'RO', name: 'Rumunia' },
  { iso: 'RW', name: 'Rwanda' },
  { iso: 'EH', name: 'Sahara Zachodnia' },
  { iso: 'KN', name: 'Saint Kitts i Nevis' },
  { iso: 'LC', name: 'Saint Lucia' },
  { iso: 'VC', name: 'Saint Vincent i Grenadyny' },
  { iso: 'BL', name: 'Saint-Barthélemy' },
  { iso: 'MF', name: 'Saint-Martin' },
  { iso: 'PM', name: 'Saint-Pierre i Miquelon' },
  { iso: 'SV', name: 'Salwador' },
  { iso: 'WS', name: 'Samoa' },
  { iso: 'AS', name: 'Samoa Amerykańskie' },
  { iso: 'SM', name: 'San Marino' },
  { iso: 'SN', name: 'Senegal' },
  { iso: 'RS', name: 'Serbia' },
  { iso: 'SC', name: 'Seszele' },
  { iso: 'SL', name: 'Sierra Leone' },
  { iso: 'SG', name: 'Singapur' },
  { iso: 'SX', name: 'Sint Maarten' },
  { iso: 'SK', name: 'Słowacja' },
  { iso: 'SI', name: 'Słowenia' },
  { iso: 'SO', name: 'Somalia' },
  { iso: 'HK', name: 'SRA Hongkong (Chiny)' },
  { iso: 'MO', name: 'SRA Makau (Chiny)' },
  { iso: 'LK', name: 'Sri Lanka' },
  { iso: 'US', name: 'Stany Zjednoczone' },
  { iso: 'SD', name: 'Sudan' },
  { iso: 'SS', name: 'Sudan Południowy' },
  { iso: 'SR', name: 'Surinam' },
  { iso: 'SJ', name: 'Svalbard i Jan Mayen' },
  { iso: 'SY', name: 'Syria' },
  { iso: 'CH', name: 'Szwajcaria' },
  { iso: 'SE', name: 'Szwecja' },
  { iso: 'TJ', name: 'Tadżykistan' },
  { iso: 'TH', name: 'Tajlandia' },
  { iso: 'TW', name: 'Tajwan' },
  { iso: 'TZ', name: 'Tanzania' },
  { iso: 'PS', name: 'Terytoria Palestyńskie' },
  { iso: 'TL', name: 'Timor Wschodni' },
  { iso: 'TG', name: 'Togo' },
  { iso: 'TK', name: 'Tokelau' },
  { iso: 'TO', name: 'Tonga' },
  { iso: 'TT', name: 'Trynidad i Tobago' },
  { iso: 'TN', name: 'Tunezja' },
  { iso: 'TR', name: 'Turcja' },
  { iso: 'TM', name: 'Turkmenistan' },
  { iso: 'TC', name: 'Turks i Caicos' },
  { iso: 'TV', name: 'Tuvalu' },
  { iso: 'UG', name: 'Uganda' },
  { iso: 'UA', name: 'Ukraina' },
  { iso: 'UY', name: 'Urugwaj' },
  { iso: 'UZ', name: 'Uzbekistan' },
  { iso: 'VU', name: 'Vanuatu' },
  { iso: 'WF', name: 'Wallis i Futuna' },
  { iso: 'VA', name: 'Watykan' },
  { iso: 'VE', name: 'Wenezuela' },
  { iso: 'HU', name: 'Węgry' },
  { iso: 'GB', name: 'Wielka Brytania' },
  { iso: 'VN', name: 'Wietnam' },
  { iso: 'IT', name: 'Włochy' },
  { iso: 'CX', name: 'Wyspa Bożego Narodzenia' },
  { iso: 'IM', name: 'Wyspa Man' },
  { iso: 'SH', name: 'Wyspa Świętej Heleny' },
  { iso: 'AX', name: 'Wyspy Alandzkie' },
  { iso: 'CK', name: 'Wyspy Cooka' },
  { iso: 'VI', name: 'Wyspy Dziewicze Stanów Zjednoczonych' },
  { iso: 'CC', name: 'Wyspy Kokosowe' },
  { iso: 'MH', name: 'Wyspy Marshalla' },
  { iso: 'FO', name: 'Wyspy Owcze' },
  { iso: 'SB', name: 'Wyspy Salomona' },
  { iso: 'ST', name: 'Wyspy Świętego Tomasza i Książęca' },
  { iso: 'ZM', name: 'Zambia' },
  { iso: 'ZW', name: 'Zimbabwe' },
  { iso: 'AE', name: 'Zjednoczone Emiraty Arabskie' },
] as const;

export type ShippingCountryIso = (typeof SHIPPING_COUNTRIES)[number]['iso'];

const BY_ISO = new Map<string, string>(SHIPPING_COUNTRIES.map((c) => [c.iso, c.name]));

export function isShippingCountryIso(value: string): value is ShippingCountryIso {
  return BY_ISO.has(value);
}

/** Polish name for a code already known to be offered; the caller validates first. */
export function shippingCountryName(iso: string): string | undefined {
  return BY_ISO.get(iso);
}
